module.exports = __webpack_public_path__ + "img/9788949123103.90c4f678.jpg";